export class SwatchAssignmentType {
  static PROPERTY = 'Property'

  static SWATCH = 'Swatch'
}
